export const theme = {
  colors: {
    // Core backgrounds
    backgroundPrimary: '#060a11',
    backgroundSecondary: '#0a0f1a',
    aviationNavy: '#0b1120',
    cockpitBlack: '#050810',

    // Accent palette
    skyBlue: '#3b82f6',
    skyBlueLight: '#60a5fa',
    skyBlueDim: 'rgba(59,130,246,0.14)',
    runwayCyan: '#06b6d4',
    radarGreen: 'rgba(34,197,94,0.18)',

    // Semantic
    successGreen: '#22c55e',
    successLight: '#4ade80',
    warningAmber: '#f59e0b',
    dangerRed: '#ef4444',
    dangerLight: '#fca5a5',
    dangerGlow: 'rgba(239,68,68,0.12)',

    // Surfaces
    surfaceGlass: 'rgba(15,22,33,0.85)',
    surfaceElevated: '#141e2e',
    surfaceCard: '#192235',
    resultBg: '#0d1a2e',
    resultBorder: '#1a2f50',

    // Borders
    borderSoft: '#111b2d',
    borderStrong: '#1e2d45',
    borderFocus: '#3b82f6',

    // Text
    textPrimary: '#e2e8f0',
    textSecondary: '#7a90b0',
    textMuted: '#3a4e68',

    // Focus
    focusRing: 'rgba(59,130,246,0.35)',

    // ── Backward-compatible aliases (old token names) ──
    surface: '#0f1621',
    background: '#060a11',
    border: '#1e2d45',
    borderMuted: '#111b2d',
    accent: '#3b82f6',
    accentLight: '#60a5fa',
    accentGlow: 'rgba(59,130,246,0.14)',
    warning: '#f59e0b',
    danger: '#ef4444',
    success: '#22c55e',
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px',
    '4xl': '96px',
  },

  radius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    '2xl': '24px',
    full: '9999px',
  },

  typography: {
    fontBody: '"Inter", "Ubuntu", system-ui, -apple-system, sans-serif',
    fontMono: '"JetBrains Mono", "Orbitron", "Courier New", monospace',
    // legacy aliases kept for GlobalStyle
    fontFamily: '"Inter", "Ubuntu", system-ui, -apple-system, sans-serif',
    fontFamilyMono: '"JetBrains Mono", "Orbitron", "Courier New", monospace',
  },

  shadows: {
    card: '0 2px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04)',
    elevated: '0 8px 32px rgba(0,0,0,0.6)',
    focus: '0 0 0 3px rgba(59,130,246,0.35)',
    danger: '0 0 0 3px rgba(239,68,68,0.25)',
    glow: '0 0 24px rgba(59,130,246,0.12)',
    resultCard: '0 4px 24px rgba(0,0,0,0.6), 0 0 0 1px rgba(59,130,246,0.08)',
    // legacy aliases
    inputFocus: '0 0 0 3px rgba(59,130,246,0.18)',
    inputError: '0 0 0 3px rgba(239,68,68,0.18)',
  },

  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
    // legacy aliases
    xs: '380px',
    sm: '480px',
    md: '768px',
    lg: '1024px',
  },

};
